export const calculateCompanyTotal = (totalAmount: number, monthDiff: number, status: string) => {
  if (status !== 'Active') {
    return 0; // No commission for non-active clients
  }

  const monthlyPayment = totalAmount; // The amount is already the monthly payment

  // First 3 months: 100% to company
  if (monthDiff <= 3) {
    return monthlyPayment;
  }

  // After 3 months: 10% to company
  return monthlyPayment * 0.1;
};